(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name manageRoles.controller:ManageRolesCtrl
   *
   * @description
   *
   */
  angular
    .module('manageRoles')
    .directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('ManageRolesCtrl', ManageRolesCtrl);

  function ManageRolesCtrl(PopupManager,CommonMasterData,ManageRoleService,MessageService,applicationConstants,CommonFuelService) {
    var vm = this;
    vm.ctrlName = 'ManageRolesCtrl';

    vm.model = {
            searchPanelToggle:true,
    		 searchCriteria:{
                 roleName:null,
                 status:null
             },
            masterList: {
            	roleNameList:[],
            	statusList:[],
            	privilageList:[],
            	componentList:[]
            },
            rolesList:[],
            initialSearchDone:false,
            selectedRole:{
            visibility : true,
            status : false
  },
            editorMode: applicationConstants.EDITOR_STATUS.ADD
        };

    vm.clickOnSearch = function () {
        vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
        vm.model.initialSearchDone = false;
    };

    vm.addNewRole = function(){
    	vm.model.editorMode =  applicationConstants.EDITOR_STATUS.ADD;
        vm.model.selectedRole = ManageRoleService.getNewRole();
        vm.model.selectedRole.visibility = true;
        vm.model.selectedRole.status = false;
//        vm.model.rolesList = [];
    };


     vm.searchRoles = function () {
      vm.model.rolesList = [];
      vm.model.initialSearchDone=true;
      vm.model.searchCriteria.pageSize = 10000000;
      vm.model.searchCriteria.startPosition = 1;
      searchRoles();

    };

    function searchRoles() {
    	ManageRoleService.setRolesSearchCriteria(vm.model.searchCriteria);
    	ManageRoleService.getRoles(
            function (rolesList) {
            	rolesList = _.each(rolesList, function(item){
            		return item.priviList = _.each(item.priviList, function(priv){
            			priv.privilageName = priv.privilageCode
            			return priv.category = priv.privilageCategory
            		});
            	});
                updateRoles(rolesList);
                vm.model.searchPanelToggle = false;
            },
            function (error) {
                MessageService.error(error);

            }
        );
    }

    vm.submitRole = function (action, selectedItem) {
        vm.model.selectedRole = selectedItem;
        if (action === applicationConstants.EDITOR_STATUS.DELETE){
            var param = {
                title: 'Confirmation',
                messages: ["Do you want to delete this record"],
                flags: selectedItem
            };
            PopupManager.openModal('CONFIRM_DIALOG', param, confirmDeleteDialog);
        }else{

            saveRole();
        }
    };

    function saveRole() {
    	ManageRoleService.saveRole(vm.model.selectedRole,
            function (response) {
                if(response.success){
                    MessageService.success('Successfully saved the record!');
                    vm.searchRoles(vm.model.searchCriteria);
                    vm.addNewRole();
                    vm.model.selectedRole.name =" ";
                    getRoleNameList();
                }else{
                    MessageService.error(response.errors[0]);
                }
            },
            function (error) {
                MessageService.error(error);
            }
        );
    }

    function confirmDeleteDialog(pass) {
        if(pass==='YES'){
        	ManageRoleService.deleteRole(vm.model.selectedRole,
                function (response) {
                    MessageService.success('Successfully deleted the record!');
                    vm.searchRoles(vm.model.searchCriteria);
                    vm.addNewRole();
                    vm.model.selectedRole.name =" ";
                    getRoleNameList();
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }
    }


    function updateRoles(roles){
      vm.model.rolesList = [];
    	angular.forEach(roles, function (rls) {
            vm.model.rolesList.push(rls);
        });
        vm.model.isElasticLoadingVisible= false;

        if(vm.model.rolesList.length===0){
          vm.addNewRole();
        }
    }

     vm.selectARole = function (selectedRowData) {
          vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
          vm.model.selectedRole = ManageRoleService.getRoleForEdit(selectedRowData);
        };

    function processRoleNameList(roleNameList) {
      angular.forEach(roleNameList, function (role) {
        role.roleDisplay = ' ' + role.roleName;
      });
    return roleNameList;
    }

    function getRoleNameList() {
      CommonMasterData.getUpdatedRoleNameList(function (roleNameList) {
        vm.model.masterList.roleNameList = processRoleNameList(roleNameList);
        vm.model.masterList.statusList = CommonFuelService.getStatusList();
        vm.model.searchCriteria.status = CommonFuelService.getDefaultStatus();
        vm.model.masterList.componentList = ManageRoleService.getcomponent();
      }, function () {
      });
    }

    getRoleNameList();

    CommonMasterData.getPrivilageList(function (response) {
    	vm.model.masterList.privilageList = ManageRoleService.formatPrivilegesForMultiSelect(response);
    },function (error) {});
  }
}());
